import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-10 sm:py-14 px-4" data-id="element-64">
      <div className="max-w-xl mx-auto text-center" data-id="element-65">
        <div className="bg-[#0d0800] border-2 border-[#FF6B00] rounded-xl p-6 sm:p-8" data-id="element-66">
          <div className="text-5xl mb-3" data-id="element-67">🛡️</div>
          <h2 className="text-2xl sm:text-3xl font-black text-[#FF6B00] mb-3" data-id="element-68">
            GARANTÍA 7 DÍAS
          </h2>
          <p className="text-white text-base sm:text-lg mb-3 leading-relaxed" data-id="element-69">
            Usalo en el aula. Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#FF6B00] text-2xl sm:text-3xl font-black mb-2" data-id="element-70">
            Devolución 100%.
          </p>
          <p className="text-gray-400 text-sm" data-id="element-71">
            Sin preguntas. Sin formularios. +3.000 docentes ya confían.
          </p>
        </div>
      </div>
    </section>;
}